import React, { useRef, useState, useEffect, Fragment } from 'react'
import Div100vh from 'react-div-100vh'
import { Link, useHistory, useLocation } from 'react-router-dom'
import LogoRipley from '../../../../assets/images/logo-agente.svg'
import OperatorsSvg from '../../../../assets/images/operators.svg'
import UbicationsSvg from '../../../../assets/images/ubication.svg'
import ProfilesSvg from '../../../../assets/images/profiles.svg'
import UsersSvg from '../../../../assets/images/users.svg'
import LogoutSvg from '../../../../assets/images/logout-white.svg'
import LogoutSvgPurple from '../../../../assets/images/logout-purple.svg'
import CalendarClock from '../../../../assets/images/calendar-clock-white.svg'
import MDIUpload from '../../../../assets/images/mdi_upload.svg'
import Dolly from '../../../../assets/images/dolly.svg'
import File from '../../../../assets/images/file.svg'
import './Layout.scss'
import Burger from '../Burger'
import useLocalStorage from '../../../hooks/useLocalStorage';

import AuthService from '../../../services/AuthService';
function Layout({ children, title, customStyles }) {

  const [showMenu, setShowMenu] = useState(false)
  const menuRef = useRef();
  const burgerRef = useRef();
  const history = useHistory()
  const location = useLocation()
  const { from } = location.state || { from: { pathname: "/" } };
  const [userappret] = useLocalStorage('userappret');

  const logout = () => {
    const localToken = localStorage.getItem('userappret') && JSON.parse(localStorage.getItem('userappret')).token
    if (!localToken) {
      history.push('/login')
      return;
    }
    AuthService.logout(JSON.parse(localStorage.getItem('userappret')).token).then(response => {
      // localStorage.removeItem('userappret');
      // localStorage.removeItem('time');
      localStorage.clear()
      // history.replace(from);
      window.location.href = '/login';
    }).catch(error => {
      return (error);
    })

  }

  const handleClick = e => {
    if (menuRef.current.contains(e.target)) {
      // inside click
      return;
    } else if (burgerRef.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    setShowMenu(false)
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);

  const voidFunction = () => { };

  const renderOptions = () => {
    const time = Date.now();

    const r = Math.random();

    const r_key = time + "_" + r;

    let options = [];
    const { roleName } = userappret;
    if (roleName === 'admin') {
      options.push(
        <Fragment key={r_key}>
          <Link key={'operadores-retiro'} style={{ textDecoration: 'none' }} to='/admin/operadores-retiro' >
            <LayoutOption
              image={OperatorsSvg}
              text='Operador de retiro'
              onClick={voidFunction}
            />
          </Link>
          <Link key={'puntos-retiro'} style={{ textDecoration: 'none' }} to='/admin/puntos-retiro' >
            <LayoutOption
              image={UbicationsSvg}
              text='Punto de retiro'
              onClick={voidFunction}
            />
          </Link>
          <Link key={'perfiles'} style={{ textDecoration: 'none' }} to='/admin/perfiles' >
            <LayoutOption
              image={ProfilesSvg}
              text='Perfiles'
              onClick={voidFunction}
            />
          </Link>
          <Link key={'usuarios'} style={{ textDecoration: 'none' }} to='/admin/usuarios' >
            <LayoutOption
              image={UsersSvg}
              text='Usuarios'
              onClick={voidFunction}
            />
          </Link>
          {/* <Link style={{ textDecoration: 'none' }} to='/admin/correos' >
            <LayoutOption
              image={UsersSvg}
              text='Correos'
              onClick={voidFunction}
            />
          </Link> */}
        </Fragment>
      )
    }
    if (roleName === 'cdadmin') {
      options.push(
        <Fragment>
          <Link key={'recepcion'} style={{ textDecoration: 'none' }} to='/admin/recepcion' >
            <LayoutOption
              image={Dolly}
              text='Recepción de pedidos'
              onClick={voidFunction}
            />
          </Link>
          <Link key={'devoluciones'} style={{ textDecoration: 'none' }} to='/admin/devoluciones' >
            <LayoutOption
              image={CalendarClock}
              text='Devolución de pedidos'
              onClick={voidFunction}
            />
          </Link>
        </Fragment>
      )
    }
    if (roleName === 'mkp') {
      options.push(
        <Link key={'crearLPN'} style={{ textDecoration: 'none' }} to='/admin/crearLPN' >
          <LayoutOption
            image={MDIUpload}
            text='Creación de LPNs'
            onClick={voidFunction}
          />
        </Link>
      )
    }
    if (roleName === 'seller' || roleName === 'mkp') {
      options.push(
        <Link key={'consultarLPN'} style={{ textDecoration: 'none' }} to='/admin/consultarLPN' >
          <LayoutOption
            image={File}
            text='Consulta de LPNs'
            onClick={voidFunction}
          />
        </Link>
      )
    }
    if (roleName === 'backoffice') {
      options.push(
        <Link key={'solicitud-evidencias'} style={{ textDecoration: 'none' }} to='/admin/solicitud-evidencias' >
          <LayoutOption
            image={MDIUpload}
            text='Solicitud de evidencias'
            onClick={voidFunction}
          />
        </Link>
      )
    }
    if (roleName === 'backoffice') {
      options.push(
        <Link key={'anulacion-cuds'} style={{ textDecoration: 'none' }} to='/admin/anulacion-cuds' >
          <LayoutOption
            image={MDIUpload}
            text='Anulación de cuds'
            onClick={voidFunction}
          />
        </Link>

      )
    }
    if (roleName === 'backoffice') {
      options.push(
        <Link key={'reenviar-correo'} style={{ textDecoration: 'none' }} to='/admin/reenviar-correo' >
          <LayoutOption
            image={MDIUpload}
            text='Reenvío de correos'
            onClick={voidFunction}
          />
        </Link>
      )
    }
    return options
  }

  return (
    <Div100vh className='layout-container'>
      <div className={`layout-menu ${showMenu ? 'show' : ''}`} ref={menuRef}>
        <div className='layout-body'>
          <img src={LogoRipley} alt='logo' />
          {renderOptions()}
        </div>
        <div className='layout-footer'>
          <LayoutOption
            image={LogoutSvg}
            text='CERRAR SESIÓN'
            onClick={logout}
          />
        </div>
      </div>
      <div className='layout-header'>
        <Burger open={showMenu} burgerRef={burgerRef} onClick={() => setShowMenu(!showMenu)} />
        <h3>{title || (location['pathname'].includes('LPN') ? 'Marketplace' : 'Administrador')}</h3>
        <img className='logout-icon' src={LogoutSvgPurple} alt='logout' onClick={logout} />
      </div>
      <div className='layout-content' style={customStyles}>
        <h2>{title || (location['pathname'].includes('LPN') ? 'Marketplace' : 'Administrador')}</h2>
        {children}
      </div>
    </Div100vh>
  )
}

const LayoutOption = ({ image, text, onClick }) => (
  <div className='layout-option' onClick={() => onClick()}>
    <img src={image} alt='opcion' />
    <p>{text}</p>
  </div>
)

export default Layout
